<template>
    <div class="forget-password-screen">
        <h1 class="title">{{ $t("signInUp.forgetPasswordTitle") }}</h1>
        <p>
            {{ $t("signInUp.forgetPasswordTutorial") }}
        </p>
        <form @submit.prevent="submitForm">
            <input
                type="email"
                v-model="email"
                @input="validateEmail"
                :placeholder="$t('signInUp.emailAddress')"
            />
            <transition name="fade" mode="out-in">
                <div class="submit-container" v-if="!isPending && !successMessage.length">
                    <input type="submit" :disabled="formInvalid" :value="$t('general.validate')" />
                </div>
                <Loader class="loader" v-else-if="isPending" />
            </transition>
        </form>
        <transition name="fade" mode="out-in">
            <div v-if="error.length > 0" class="error-message">
                {{ error }}
            </div>
            <router-link to="SignIn" v-else-if="successMessage.length > 0" class="success-message">
                {{ successMessage }}
            </router-link>
        </transition>
        <div class="view-footer">
            <RGPDLink />
            <GcuLink class="gcu-link" v-if="$t('general.GCU').length" />
        </div>
    </div>
</template>
<script lang="ts">
import getAuthService from "@/services/AuthService";
import Loader from "@/components/Loader.vue";
import RGPDLink from "@/components/RGPDLink.vue";
import GcuLink from "@/components/gcuLink.vue";
export default {
    name: "ForgetPassword",
    components: {
        Loader,
        GcuLink,
        RGPDLink
    },
    data() {
        return {
            email: "",
            isPending: false,
            successMessage: "",
            error: "",
            timer: null as null | number
        };
    },
    computed: {
        formInvalid() {
            return this.email.length < 3;
        }
    },
    beforeUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    },
    methods: {
        async submitForm() {
            this.error = "";
            this.isPending = true;
            try {
                await getAuthService().forgetPassword(this.email);
                this.isPending = false;
                this.successMessage = this.$t("signInUp.forgetPasswordSuccess");
                this.timer = setTimeout(() => this.$router.replace("SignIn"), 3000);
            } catch (e) {
                this.isPending = false;
                this.error = this.$t("errorsUid." + (e.response?.data?.uid || e.code || e.message));
            }
        },

        validateEmail(ev: Event) {
            const input = ev.target as HTMLInputElement;
            input.value = input.value.toLowerCase();
        }
    }
};
</script>
<style scoped>
.forget-password-screen {
    display: flex;
    flex-direction: column;
    align-items: center;
}

h1 {
    margin: 0;
}

.forget-password-screen form {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 15px;
    align-items: center;
    justify-content: center;
}

input[type="email"] {
    padding: 10px 20px;
    border-radius: calc(1em + 10px);
    line-height: 1em;
    background: #fff;
    border: 0;
    margin-left: auto;
    margin-right: auto;
}

.submit-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

input[type="submit"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin-bottom: 15px;
    padding: 10px 20px;
    border-radius: calc(1em + 10px);
    line-height: 1em;
    border: 0;
    background: var(--secondary);
    color: var(--white);
    transition: filter 0.2s ease-in;
}

.error-message {
    color: var(--red);
}

.success-message {
    color: var(--secondary);
    text-decoration: none;
    padding: 5px 10px;
    border-radius: 15px;
    margin-top: 15px;
}

.view-footer {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}
</style>
